export const navbarHeight = `131px`